module.exports = require("./../../_gen/starling/textures/SubTexture");